// Generated by scripts/logo/build-logo.py from docs/logo-source.png. Do not edit.
//
// Ink is `currentColor`, so one component covers both themes: the mark inherits
// whatever colour the surrounding text has. The check keeps its hue via --logo-check.
import type {SVGProps} from "react";

type SvgProps = SVGProps<SVGSVGElement> & {title?: string};

export function StampdMark({title, ...props}: SvgProps) {
    return (
        <svg
            viewBox="0 0 834 786"
            xmlns="http://www.w3.org/2000/svg"
            role={title ? "img" : "presentation"}
            aria-label={title}
            aria-hidden={title ? undefined : true}
            focusable="false"
            {...props}
        >
            <g transform="translate(0.000000,786.000000) scale(0.100000,-0.100000)" fill="currentColor" stroke="none"><path d="M3715 7574 c-220 -21 -429 -48 -490 -63 -22 -5 -62 -14 -90 -20 -27
-6 -68 -16 -90 -22 -22 -5 -56 -14 -75 -19 -123 -29 -427 -136 -560 -197 -285
-129 -525 -270 -723 -422 -54 -42 -109 -83 -121 -91 -41 -28 -250 -217 -322
-292 -289 -300 -482 -569 -641 -890 -35 -70 -63 -130 -63 -133 0 -3 -9 -27
-21 -53 -11 -26 -26 -61 -33 -77 -17 -38 -96 -270 -107 -310 -41 -157 -51
-199 -63 -260 -8 -38 -19 -99 -25 -135 -6 -36 -16 -99 -23 -140 -17 -102 -17
-648 0 -795 13 -111 19 -156 46 -320 18 -109 79 -343 117 -445 7 -19 30 -84
52 -145 41 -111 137 -328 182 -410 14 -25 36 -65 50 -90 64 -117 198 -304 350
-490 102 -125 372 -395 394 -395 14 1 91 63 91 75 0 3 18 21 40 41 22 20 40
41 40 47 0 6 -46 56 -103 111 -56 56 -116 117 -132 136 -16 19 -53 62 -84 95
-183 200 -497 716 -556 915 -4 14 -11 30 -15 35 -29 38 -152 477 -178 635 -52
306 -67 631 -42 854 26 221 31 264 41 321 11 59 24 117 39 165 4 14 13 45 20
70 25 89 30 106 61 200 17 52 40 113 50 134 11 22 19 43 19 48 0 16 146 305
190 378 26 41 62 100 80 130 19 30 61 91 94 135 33 44 75 100 94 125 117 155
385 420 572 566 305 237 559 374 1015 545 171 64 440 131 635 159 36 6 94 14
130 20 115 18 486 39 608 35 295 -11 408 -20 547 -45 28 -5 82 -14 120 -20
251 -43 620 -155 850 -260 231 -105 362 -177 528 -289 54 -36 106 -70 115 -76
9 -5 41 -27 69 -49 43 -31 58 -37 80 -31 33 8 153 131 153 157 0 24 -139 127
-340 255 -135 85 -318 182 -485 256 -55 25 -125 56 -155 70 -30 13 -84 34
-120 47 -36 12 -72 26 -81 31 -9 4 -52 18 -95 30 -43 12 -117 32 -164 46 -399
112 -1027 162 -1475 117z"/><path d="M6880 6502 c0 -5 -31 -41 -70 -80 -38 -39 -70 -79 -70 -88 0 -10 24
-40 53 -68 197 -188 439 -502 572 -740 121 -218 178 -337 231 -484 25 -70 50
-136 55 -147 4 -11 21 -60 37 -110 28 -85 35 -112 62 -230 6 -27 15 -66 20
-85 9 -35 13 -61 32 -205 66 -521 9 -1114 -152 -1560 -84 -234 -254 -569 -364
-721 -181 -249 -237 -316 -406 -485 -172 -173 -230 -221 -471 -389 -141 -98
-447 -260 -639 -338 -229 -93 -423 -149 -747 -217 -423 -89 -1018 -83 -1498
14 -272 55 -451 111 -770 240 -51 20 -354 171 -422 210 -68 39 -247 160 -346
233 -43 32 -86 58 -94 58 -16 0 -130 -111 -159 -155 -15 -23 -15 -27 -1 -38
31 -25 213 -161 242 -182 130 -94 461 -273 645 -350 36 -15 81 -34 100 -42 58
-25 439 -148 555 -179 285 -76 696 -123 1075 -124 197 0 276 5 515 36 165 21
206 28 330 54 22 5 67 14 100 21 102 20 207 49 280 75 39 14 84 30 100 34 143
38 515 208 718 328 509 301 960 761 1253 1277 75 131 204 400 204 424 0 6 4
19 10 29 16 28 101 299 113 362 3 14 12 54 21 90 23 92 33 144 46 230 6 41 15
102 20 135 40 257 36 737 -8 1030 -23 150 -89 435 -131 560 -85 254 -115 329
-204 510 -99 201 -265 466 -385 616 -20 25 -64 79 -97 120 -136 169 -355 373
-355 331z"/><path d="M2180 5741 c0 -126 -2 -235 -5 -243 -9 -24 11 -38 67 -48 31 -5 64
-13 75 -18 10 -6 33 -16 52 -23 74 -28 113 -147 77 -234 -15 -35 -84 -93 -120
-100 -161 -31 -146 -11 -146 -196 0 -92 -2 -174 -5 -182 -5 -11 8 -15 57 -20
164 -16 228 -74 228 -204 0 -107 -66 -172 -190 -188 -98 -12 -90 5 -90 -185 0
-93 3 -175 6 -184 5 -12 20 -16 58 -16 193 0 285 -205 150 -330 -44 -40 -44
-40 -129 -40 l-85 0 2 -197 c3 -198 3 -198 69 -209 135 -22 209 -87 209 -184
-1 -119 -85 -190 -229 -190 -51 0 -51 0 -49 -192 3 -192 3 -192 73 -203 168
-26 243 -137 180 -268 -31 -66 -83 -94 -207 -112 -48 -6 -48 -6 -48 -161 l0
-154 245 0 c245 0 245 0 245 38 0 50 49 151 87 179 78 56 198 38 257 -39 17
-23 31 -59 39 -104 12 -69 12 -69 182 -69 170 0 170 0 176 50 18 141 71 206
166 204 85 -2 155 -68 169 -162 4 -28 9 -55 10 -59 1 -5 2 -15 3 -23 1 -13 25
-15 173 -13 173 3 173 3 189 78 19 89 30 112 67 139 83 58 210 44 258 -29 15
-22 27 -58 30 -91 11 -96 16 -99 152 -98 64 0 140 4 167 7 50 7 50 7 55 67 8
91 33 126 119 172 43 23 72 16 159 -38 25 -16 52 -71 52 -107 0 -15 5 -44 11
-65 10 -37 10 -37 663 -37 653 0 653 0 658 37 4 28 2 1117 -1 1166 -1 4 -38 7
-83 5 l-83 -3 -3 -170 c-1 -93 -6 -199 -11 -235 -9 -64 -7 -202 2 -250 3 -14
6 -29 6 -34 1 -4 8 -6 16 -2 10 4 15 -1 15 -14 0 -12 -9 -22 -24 -26 -37 -9
-49 -106 -31 -237 10 -68 0 -74 -79 -42 -103 41 -126 42 -198 7 -93 -44 -104
-44 -167 11 -31 27 -39 29 -84 23 -29 -3 -59 -14 -71 -25 -45 -42 -73 -44
-141 -11 -80 39 -119 39 -173 -1 -51 -38 -64 -34 -82 22 -32 99 -87 151 -201
188 -132 44 -234 17 -339 -89 -47 -46 -72 -81 -86 -120 -12 -30 -25 -54 -30
-53 -5 2 -17 28 -28 59 -21 65 -103 155 -176 193 -66 34 -196 40 -270 12 -86
-33 -159 -97 -201 -177 -41 -78 -69 -91 -80 -38 -13 67 -100 163 -179 200 -66
31 -160 41 -225 25 -95 -24 -212 -129 -244 -219 -20 -54 -42 -61 -52 -15 -37
180 -311 298 -479 207 -64 -35 -170 -146 -170 -178 0 -41 -34 -60 -116 -64
-51 -3 -74 -1 -74 7 0 6 8 14 18 17 157 49 242 169 242 343 0 148 -97 276
-238 316 -34 10 -56 49 -42 74 6 12 16 21 23 21 31 0 121 54 162 96 71 73 89
120 93 245 3 98 2 110 -22 155 -42 81 -86 120 -178 164 -47 22 -89 47 -92 56
-9 24 10 51 41 59 143 35 240 153 251 307 12 173 -66 302 -226 374 -47 22 -53
27 -50 51 2 22 12 30 53 45 69 25 124 67 167 129 49 71 61 119 56 226 -6 154
-80 265 -209 314 -53 21 -65 29 -67 50 -4 30 15 47 88 79 68 30 92 50 133 115
46 70 57 110 57 198 0 159 -91 290 -227 326 -23 6 -45 17 -50 24 -13 16 -23
115 -16 165 5 40 5 40 92 44 47 2 91 0 97 -4 7 -5 22 -34 34 -66 25 -64 80
-123 150 -162 42 -23 55 -25 170 -24 114 0 130 2 181 27 70 33 138 106 163
175 19 54 33 65 42 35 15 -50 62 -128 93 -155 112 -99 329 -114 461 -32 47 29
103 91 119 134 20 54 27 65 45 68 11 2 16 -3 16 -17 0 -41 82 -159 123 -179
120 -56 119 -56 224 -54 75 1 114 7 145 20 24 11 55 24 70 30 36 15 109 110
123 159 12 41 41 57 51 26 32 -98 91 -168 173 -206 59 -27 76 -30 166 -30 167
-1 263 53 322 179 34 74 49 89 59 57 3 -10 10 -26 15 -35 5 -10 9 -22 9 -28 0
-6 15 -33 33 -60 107 -164 477 -153 589 18 14 20 30 54 37 74 16 48 18 49 99
53 104 6 102 9 102 -100 0 -93 0 -93 -56 -125 -151 -85 -212 -195 -202 -367 7
-136 77 -234 205 -290 85 -37 87 -63 9 -98 -72 -32 -160 -119 -191 -190 -35
-78 -35 -223 -1 -307 39 -95 141 -198 196 -198 30 0 53 -25 47 -51 -5 -17 -23
-31 -64 -49 -233 -99 -282 -433 -88 -593 31 -25 78 -56 106 -68 33 -15 52 -30
55 -45 8 -31 2 -38 -48 -54 -141 -46 -273 -200 -213 -250 8 -7 24 -10 34 -7
11 3 28 -1 38 -9 34 -25 62 -16 122 41 61 58 118 85 182 85 38 0 38 0 41 93 2
50 1 137 0 192 -4 100 -4 100 -60 100 -134 1 -203 67 -206 195 -1 59 2 71 28
104 15 21 33 39 40 41 6 1 35 10 65 19 29 9 66 16 81 16 59 0 63 15 57 209 -3
97 -6 177 -6 179 -1 1 -30 2 -65 2 -142 0 -226 105 -201 252 7 38 78 128 91
115 3 -3 31 1 62 9 31 7 69 13 85 14 19 0 27 5 28 18 2 32 -2 357 -5 359 -1 1
-29 5 -61 9 -77 7 -152 47 -180 94 -39 67 -21 184 37 237 24 22 132 63 167 63
48 0 51 17 50 248 -1 120 -3 227 -6 240 -5 22 -5 22 -257 20 -251 -3 -251 -3
-258 -60 -23 -186 -187 -255 -332 -138 -29 23 -56 96 -56 151 0 49 0 49 -172
47 -173 -3 -173 -3 -178 -73 -7 -100 -46 -154 -125 -174 -53 -13 -115 1 -170
39 -48 33 -63 64 -72 153 -6 57 -6 57 -173 57 -184 0 -180 2 -180 -63 0 -47
-43 -131 -81 -158 -48 -34 -141 -39 -197 -10 -67 34 -112 115 -112 200 0 31 0
31 -169 31 -181 0 -195 -4 -189 -52 12 -101 -44 -176 -150 -197 -72 -14 -116
2 -170 64 -35 39 -41 56 -44 130 -3 50 -3 50 -173 50 -170 0 -170 0 -176 -60
-9 -98 -42 -145 -126 -180 -69 -29 -168 -4 -213 52 -20 25 -46 106 -52 158 -3
30 -3 30 -255 33 l-253 2 0 -229z"/><path d="M6200 2836 c0 -9 5 -16 10 -16 6 0 10 4 10 9 0 6 -4 13 -10 16 -5 3
-10 -1 -10 -9z"/><path d="M6005 2730 c-3 -5 1 -10 9 -10 9 0 16 5 16 10 0 6 -4 10 -9 10 -6 0
-13 -4 -16 -10z"/><path d="M5959 2423 c-24 -28 -24 -28 4 -4 15 14 27 26 27 28 0 8 -8 1 -31
-24z"/><path d="M5426 2310 c21 -22 40 -38 42 -35 7 6 -58 75 -70 75 -5 0 8 -18 28
-40z"/><path d="M5800 2285 c-13 -14 -21 -27 -18 -30 2 -3 17 9 33 25 16 17 24 30 19
30 -6 0 -21 -11 -34 -25z"/><path d="M5628 2138 c17 -8 26 -8 34 0 9 9 4 12 -22 11 -33 0 -34 -1 -12 -11z"/></g>
            <g transform="translate(0.000000,786.000000) scale(0.100000,-0.100000)" fill="var(--logo-check)" stroke="none"><path d="M6163 2840 c-3 -12 -24 -29 -47 -40 -43 -19 -69 -43 -79 -72 -4 -11
-17 -18 -32 -18 -14 0 -25 -6 -25 -13 0 -16 -68 -82 -93 -90 -9 -4 -22 -18
-27 -32 -5 -14 -15 -25 -23 -25 -16 0 -137 -121 -137 -138 0 -7 -11 -17 -25
-22 -14 -5 -30 -21 -35 -35 -12 -31 -18 -31 -30 0 -5 14 -21 30 -35 35 -14 5
-25 15 -25 22 0 7 -10 18 -22 23 -13 6 -28 20 -34 33 -16 32 -65 82 -81 82 -7
0 -18 11 -23 25 -13 35 -37 41 -63 18 -12 -11 -29 -23 -38 -26 -9 -3 -23 -19
-32 -35 -14 -30 -14 -30 57 -101 39 -39 76 -71 82 -71 13 0 84 -73 84 -86 0
-13 63 -74 76 -74 6 0 19 -9 29 -20 29 -32 94 -27 130 10 16 17 35 30 42 30 7
0 13 10 13 23 0 23 47 77 66 77 6 0 23 14 39 30 16 17 35 30 42 30 7 0 13 5
13 12 0 15 50 68 65 68 15 0 229 220 245 252 10 21 10 30 1 42 -9 10 -9 16 -1
21 14 9 -6 35 -26 35 -8 0 -19 11 -24 25 -12 30 -20 32 -27 5z"/></g>
        </svg>
    );
}

export function StampdLockup({title, ...props}: SvgProps) {
    return (
        <svg
            viewBox="0 0 1082 1136"
            xmlns="http://www.w3.org/2000/svg"
            role={title ? "img" : "presentation"}
            aria-label={title}
            aria-hidden={title ? undefined : true}
            focusable="false"
            {...props}
        >
            <g transform="translate(0.000000,1136.000000) scale(0.100000,-0.100000)" fill="currentColor" stroke="none"><path d="M5055 11074 c-220 -21 -429 -48 -490 -63 -22 -5 -62 -14 -90 -20 -27
-6 -68 -16 -90 -22 -22 -5 -56 -14 -75 -19 -123 -29 -427 -136 -560 -197 -285
-129 -525 -270 -723 -422 -54 -42 -109 -83 -121 -91 -41 -28 -250 -217 -322
-292 -289 -300 -482 -569 -641 -890 -35 -70 -63 -130 -63 -133 0 -3 -9 -27
-21 -53 -11 -26 -26 -61 -33 -77 -17 -38 -96 -270 -107 -310 -41 -157 -51
-199 -63 -260 -8 -38 -19 -99 -25 -135 -6 -36 -16 -99 -23 -140 -17 -102 -17
-648 0 -795 13 -111 19 -156 46 -320 18 -109 79 -343 117 -445 7 -19 30 -84
52 -145 41 -111 137 -328 182 -410 14 -25 36 -65 50 -90 64 -117 198 -304 350
-490 102 -125 372 -395 394 -395 14 1 91 63 91 75 0 3 18 21 40 41 22 20 40
41 40 47 0 6 -46 56 -103 111 -56 56 -116 117 -132 136 -16 19 -53 62 -84 95
-183 200 -497 716 -556 915 -4 14 -11 30 -15 35 -29 38 -152 477 -178 635 -52
306 -67 631 -42 854 26 221 31 264 41 321 11 59 24 117 39 165 4 14 13 45 20
70 25 89 30 106 61 200 17 52 40 113 50 134 11 22 19 43 19 48 0 16 146 305
190 378 26 41 62 100 80 130 19 30 61 91 94 135 33 44 75 100 94 125 117 155
385 420 572 566 305 237 559 374 1015 545 171 64 440 131 635 159 36 6 94 14
130 20 115 18 486 39 608 35 295 -11 408 -20 547 -45 28 -5 82 -14 120 -20
251 -43 620 -155 850 -260 231 -105 362 -177 528 -289 54 -36 106 -70 115 -76
9 -5 41 -27 69 -49 43 -31 58 -37 80 -31 33 8 153 131 153 157 0 24 -139 127
-340 255 -135 85 -318 182 -485 256 -55 25 -125 56 -155 70 -30 13 -84 34
-120 47 -36 12 -72 26 -81 31 -9 4 -52 18 -95 30 -43 12 -117 32 -164 46 -399
112 -1027 162 -1475 117z"/><path d="M8220 10002 c0 -5 -31 -41 -70 -80 -38 -39 -70 -79 -70 -88 0 -10 24
-40 53 -68 197 -188 439 -502 572 -740 121 -218 178 -337 231 -484 25 -70 50
-136 55 -147 4 -11 21 -60 37 -110 28 -85 35 -112 62 -230 6 -27 15 -66 20
-85 9 -35 13 -61 32 -205 66 -521 9 -1114 -152 -1560 -84 -234 -254 -569 -364
-721 -181 -249 -237 -316 -406 -485 -172 -173 -230 -221 -471 -389 -141 -98
-447 -260 -639 -338 -229 -93 -423 -149 -747 -217 -423 -89 -1018 -83 -1498
14 -272 55 -451 111 -770 240 -51 20 -354 171 -422 210 -68 39 -247 160 -346
233 -43 32 -86 58 -94 58 -16 0 -130 -111 -159 -155 -15 -23 -15 -27 -1 -38
31 -25 213 -161 242 -182 130 -94 461 -273 645 -350 36 -15 81 -34 100 -42 58
-25 439 -148 555 -179 285 -76 696 -123 1075 -124 197 0 276 5 515 36 165 21
206 28 330 54 22 5 67 14 100 21 102 20 207 49 280 75 39 14 84 30 100 34 143
38 515 208 718 328 509 301 960 761 1253 1277 75 131 204 400 204 424 0 6 4
19 10 29 16 28 101 299 113 362 3 14 12 54 21 90 23 92 33 144 46 230 6 41 15
102 20 135 40 257 36 737 -8 1030 -23 150 -89 435 -131 560 -85 254 -115 329
-204 510 -99 201 -265 466 -385 616 -20 25 -64 79 -97 120 -136 169 -355 373
-355 331z"/><path d="M3520 9241 c0 -126 -2 -235 -5 -243 -9 -24 11 -38 67 -48 31 -5 64
-13 75 -18 10 -6 33 -16 52 -23 74 -28 113 -147 77 -234 -15 -35 -84 -93 -120
-100 -161 -31 -146 -11 -146 -196 0 -92 -2 -174 -5 -182 -5 -11 8 -15 57 -20
164 -16 228 -74 228 -204 0 -107 -66 -172 -190 -188 -98 -12 -90 5 -90 -185 0
-93 3 -175 6 -184 5 -12 20 -16 58 -16 193 0 285 -205 150 -330 -44 -40 -44
-40 -129 -40 l-85 0 2 -197 c3 -198 3 -198 69 -209 135 -22 209 -87 209 -184
-1 -119 -85 -190 -229 -190 -51 0 -51 0 -49 -192 3 -192 3 -192 73 -203 168
-26 243 -137 180 -268 -31 -66 -83 -94 -207 -112 -48 -6 -48 -6 -48 -161 l0
-154 245 0 c245 0 245 0 245 38 0 50 49 151 87 179 78 56 198 38 257 -39 17
-23 31 -59 39 -104 12 -69 12 -69 182 -69 170 0 170 0 176 50 18 141 71 206
166 204 85 -2 155 -68 169 -162 4 -28 9 -55 10 -59 1 -5 2 -15 3 -23 1 -13 25
-15 173 -13 173 3 173 3 189 78 19 89 30 112 67 139 83 58 210 44 258 -29 15
-22 27 -58 30 -91 11 -96 16 -99 152 -98 64 0 140 4 167 7 50 7 50 7 55 67 8
91 33 126 119 172 43 23 72 16 159 -38 25 -16 52 -71 52 -107 0 -15 5 -44 11
-64 10 -38 10 -38 663 -38 653 0 653 0 658 38 4 27 2 1116 -1 1165 -1 4 -38 7
-83 5 l-83 -3 -3 -170 c-1 -93 -6 -199 -11 -235 -9 -64 -7 -202 2 -250 3 -14
6 -29 6 -34 1 -4 8 -6 16 -2 10 4 15 -1 15 -14 0 -12 -9 -22 -24 -26 -37 -9
-49 -106 -31 -237 10 -68 0 -74 -79 -42 -103 41 -126 42 -198 7 -93 -44 -104
-44 -167 11 -31 27 -39 29 -84 23 -29 -3 -59 -14 -71 -25 -45 -42 -73 -44
-141 -11 -80 39 -119 39 -173 -1 -51 -38 -64 -34 -82 22 -32 99 -87 151 -201
188 -132 44 -234 17 -339 -89 -47 -46 -72 -81 -86 -120 -12 -30 -25 -54 -30
-52 -5 1 -17 27 -28 58 -21 65 -103 155 -176 193 -66 34 -196 40 -270 12 -86
-33 -159 -97 -201 -177 -41 -78 -69 -91 -80 -38 -13 67 -100 163 -179 200 -66
31 -160 41 -225 25 -95 -24 -212 -129 -244 -219 -20 -54 -42 -61 -52 -15 -37
180 -311 298 -479 207 -64 -35 -170 -146 -170 -178 0 -41 -34 -60 -116 -64
-51 -3 -74 -1 -74 7 0 6 8 14 18 17 157 49 242 169 242 343 0 148 -97 276
-238 316 -34 10 -56 49 -42 74 6 12 16 21 23 21 31 0 121 54 162 96 71 73 89
120 93 245 3 98 2 110 -22 155 -42 81 -86 120 -178 164 -47 22 -89 47 -92 56
-9 24 10 51 41 59 143 35 240 153 251 307 12 173 -66 302 -226 374 -47 22 -53
27 -50 51 2 22 12 30 53 45 69 25 124 67 167 129 49 71 61 119 56 226 -6 154
-80 265 -209 314 -53 21 -65 29 -67 50 -4 30 15 47 88 79 68 30 92 50 133 115
46 70 57 110 57 198 0 159 -91 290 -227 326 -23 6 -45 17 -50 24 -13 16 -23
115 -16 165 5 40 5 40 92 44 47 2 91 0 97 -4 7 -5 22 -34 34 -66 25 -64 80
-123 150 -162 42 -23 55 -25 170 -24 114 0 130 2 181 27 70 33 138 106 163
175 19 54 33 65 42 35 15 -50 62 -128 93 -155 112 -99 329 -114 461 -32 47 29
103 91 119 134 20 54 27 65 45 68 11 2 16 -3 16 -17 0 -41 82 -159 123 -179
120 -56 119 -56 224 -54 75 1 114 7 145 20 24 11 55 24 70 30 36 15 109 110
123 159 12 41 41 57 51 26 32 -98 91 -168 173 -206 59 -27 76 -30 166 -30 167
-1 263 53 322 179 34 74 49 89 59 57 3 -10 10 -26 15 -35 5 -10 9 -22 9 -28 0
-6 15 -33 33 -60 107 -164 477 -153 589 18 14 20 30 54 37 74 16 48 18 49 99
53 104 6 102 9 102 -100 0 -93 0 -93 -56 -125 -151 -85 -212 -195 -202 -367 7
-136 77 -234 205 -290 85 -37 87 -63 9 -98 -72 -32 -160 -119 -191 -190 -35
-78 -35 -223 -1 -307 39 -95 141 -198 196 -198 30 0 53 -25 47 -51 -5 -17 -23
-31 -64 -49 -233 -99 -282 -433 -88 -593 31 -25 78 -56 106 -68 33 -15 52 -30
55 -45 8 -31 2 -38 -48 -54 -141 -46 -273 -200 -213 -250 8 -7 24 -10 34 -7
11 3 28 -1 38 -9 34 -25 62 -16 122 41 61 58 118 85 182 85 38 0 38 0 41 93 2
50 1 137 0 192 -4 100 -4 100 -60 100 -134 1 -203 67 -206 195 -1 59 2 71 28
104 15 21 33 39 40 41 6 1 35 10 65 19 29 9 66 16 81 16 59 0 63 15 57 209 -3
97 -6 177 -6 179 -1 1 -30 2 -65 2 -142 0 -226 105 -201 252 7 38 78 128 91
115 3 -3 31 1 62 9 31 7 69 13 85 14 19 0 27 5 28 18 2 32 -2 357 -5 359 -1 1
-29 5 -61 9 -77 7 -152 47 -180 94 -39 67 -21 184 37 237 24 22 132 63 167 63
48 0 51 17 50 248 -1 120 -3 227 -6 240 -5 22 -5 22 -257 20 -251 -3 -251 -3
-258 -60 -23 -186 -187 -255 -332 -138 -29 23 -56 96 -56 151 0 49 0 49 -172
47 -173 -3 -173 -3 -178 -73 -7 -100 -46 -154 -125 -174 -53 -13 -115 1 -170
39 -48 33 -63 64 -72 153 -6 57 -6 57 -173 57 -184 0 -180 2 -180 -63 0 -47
-43 -131 -81 -158 -48 -34 -141 -39 -197 -10 -67 34 -112 115 -112 200 0 31 0
31 -169 31 -181 0 -195 -4 -189 -52 12 -101 -44 -176 -150 -197 -72 -14 -116
2 -170 64 -35 39 -41 56 -44 130 -3 50 -3 50 -173 50 -170 0 -170 0 -176 -60
-9 -98 -42 -145 -126 -180 -69 -29 -168 -4 -213 52 -20 25 -46 106 -52 158 -3
30 -3 30 -255 33 l-253 2 0 -229z"/><path d="M7540 6336 c0 -9 5 -16 10 -16 6 0 10 4 10 9 0 6 -4 13 -10 16 -5 3
-10 -1 -10 -9z"/><path d="M7345 6230 c-3 -5 1 -10 9 -10 9 0 16 5 16 10 0 6 -4 10 -9 10 -6 0
-13 -4 -16 -10z"/><path d="M7299 5923 c-24 -28 -24 -28 4 -4 25 23 32 31 24 31 -2 0 -14 -12
-28 -27z"/><path d="M6766 5810 c21 -22 40 -38 42 -35 7 6 -58 75 -70 75 -5 0 8 -18 28
-40z"/><path d="M7140 5785 c-13 -14 -21 -27 -18 -30 2 -3 17 9 33 25 16 17 24 30 19
30 -6 0 -21 -11 -34 -25z"/><path d="M6968 5638 c17 -8 26 -8 34 0 9 9 4 12 -22 11 -33 0 -34 -1 -12 -11z"/><path d="M10302 3036 c3 -299 5 -292 -52 -231 -99 107 -377 156 -570 101 -132
-38 -205 -78 -281 -155 -118 -121 -169 -239 -177 -412 -16 -388 252 -659 652
-659 52 0 119 6 149 14 70 18 182 78 227 122 20 19 40 34 45 34 6 0 10 -33 10
-72 0 -73 0 -73 130 -73 l130 0 3 780 c1 429 0 790 -3 803 -5 21 -9 22 -135
22 l-131 0 3 -274z m-263 -332 c174 -60 261 -190 261 -392 0 -148 -39 -252
-121 -326 -163 -146 -428 -138 -585 18 -82 83 -106 146 -108 285 -1 125 10
176 52 246 47 76 115 133 201 166 61 23 237 25 300 3z"/><path d="M2038 3073 l-3 -158 -125 -5 -125 -5 0 -100 0 -100 125 -5 125 -5 6
-350 c5 -322 7 -355 27 -416 43 -132 139 -215 273 -238 151 -26 398 3 448 53
23 24 24 26 11 84 -21 92 -27 98 -92 76 -36 -12 -85 -18 -153 -18 -92 -1 -104
1 -148 27 -92 54 -99 89 -95 482 l3 300 215 6 c118 3 216 6 218 7 1 1 2 47 2
102 l0 101 -207 -1 c-115 0 -214 -1 -220 0 -10 0 -13 39 -13 160 l0 160 -135
0 -134 0 -3 -157z"/><path d="M600 2920 c-14 -4 -45 -13 -70 -20 -91 -26 -212 -116 -248 -185 -29
-55 -43 -150 -31 -208 37 -184 164 -254 574 -317 125 -19 229 -56 261 -91 21
-23 30 -100 15 -127 -38 -71 -196 -106 -381 -85 -122 13 -191 37 -275 93 -65
44 -92 49 -102 23 -4 -10 -24 -40 -45 -68 -21 -27 -38 -54 -38 -60 0 -5 34
-34 75 -63 133 -96 283 -134 500 -130 183 3 274 27 381 102 118 83 165 184
145 310 -28 168 -148 259 -386 295 -101 15 -324 61 -366 76 -93 33 -135 96
-105 159 20 41 27 47 100 76 74 30 236 32 331 5 67 -19 220 -89 230 -105 13
-21 42 -9 64 28 12 20 35 55 51 77 33 46 32 47 -23 82 -115 73 -206 110 -323
132 -68 12 -296 14 -334 1z"/><path d="M3610 2920 c-14 -4 -45 -13 -70 -20 -148 -43 -288 -153 -354 -280
-170 -324 -58 -715 249 -868 120 -60 193 -75 338 -70 167 7 264 43 372 140 23
21 45 35 48 31 4 -3 7 -39 7 -80 0 -73 0 -73 125 -73 l125 0 0 605 0 606 -122
-3 c-123 -3 -123 -3 -126 -68 -4 -98 -6 -99 -61 -45 -51 50 -141 96 -237 121
-59 15 -251 18 -294 4z m358 -240 c86 -39 138 -93 183 -186 28 -57 30 -69 31
-195 1 -132 1 -135 -31 -197 -40 -79 -103 -141 -189 -183 -64 -32 -72 -33
-177 -33 -100 1 -116 4 -175 31 -142 65 -240 222 -240 386 0 120 39 221 118
309 69 76 161 108 307 104 90 -1 107 -5 173 -36z"/><path d="M5465 2917 c-16 -5 -49 -17 -72 -25 -23 -8 -72 -39 -108 -69 -37 -30
-69 -52 -72 -49 -3 3 -6 30 -6 61 0 32 -5 59 -12 65 -8 7 -57 10 -121 8 -109
-3 -109 -3 -107 -33 1 -16 4 -280 7 -585 3 -305 5 -563 5 -572 1 -16 14 -18
126 -18 l125 0 0 318 c1 450 15 534 107 626 81 83 237 102 352 43 127 -64 131
-81 131 -595 l0 -393 128 3 127 3 5 400 c5 400 5 400 32 456 105 218 459 212
538 -8 10 -28 15 -142 19 -443 l6 -405 121 -3 c92 -2 123 1 125 10 2 7 1 209
-2 448 -7 475 -8 487 -68 574 -43 63 -127 131 -186 151 -175 60 -282 61 -463
6 -54 -16 -136 -68 -176 -111 -38 -41 -38 -41 -98 19 -64 63 -132 102 -210
120 -58 14 -213 13 -253 -2z"/><path d="M7985 2915 c-105 -25 -219 -85 -263 -137 -13 -16 -27 -28 -30 -28 -4
0 -7 35 -7 77 0 78 0 78 -100 81 -55 2 -110 0 -123 -3 -22 -5 -22 -5 -20 -833
l3 -827 116 -3 c88 -2 119 1 127 11 8 9 12 103 12 300 1 312 1 313 54 258 36
-38 162 -101 223 -113 228 -45 432 -2 600 124 146 111 213 262 213 478 -1 180
-35 281 -134 402 -127 154 -297 229 -513 227 -60 -1 -131 -7 -158 -14z m323
-229 c114 -57 187 -151 217 -278 17 -72 20 -184 5 -193 -5 -3 -10 -17 -10 -31
0 -72 -114 -215 -209 -261 -86 -43 -253 -46 -347 -9 -124 50 -186 109 -234
222 -27 62 -30 258 -5 331 39 115 129 198 260 241 17 6 81 11 143 11 109 1
115 0 180 -33z"/><path d="M5884 677 c-2 -7 -3 -107 -2 -222 3 -210 3 -210 33 -210 30 0 30 0
35 108 6 133 17 147 110 147 85 0 100 -24 100 -154 0 -94 0 -96 25 -102 47
-12 54 7 48 119 -7 124 -20 158 -70 183 -47 23 -127 24 -170 3 -41 -22 -43
-19 -43 62 0 61 -2 67 -22 73 -33 8 -38 8 -44 -7z"/><path d="M5447 653 c-4 -3 -7 -23 -7 -43 0 -42 -14 -60 -48 -60 -37 0 -26 -43
13 -50 30 -5 30 -5 35 -100 3 -52 11 -105 17 -116 25 -43 132 -59 173 -26 35
28 17 52 -40 52 -61 0 -67 9 -71 105 -4 80 -4 80 54 83 57 3 58 4 55 30 -3 25
-6 27 -53 27 -50 0 -50 0 -59 53 -9 47 -12 52 -36 52 -15 0 -30 -3 -33 -7z"/><path d="M4051 557 c-91 -20 -97 -77 -6 -60 71 13 143 8 165 -12 39 -35 26
-42 -92 -47 -110 -5 -111 -5 -140 -36 -84 -95 52 -203 185 -147 20 8 38 19 42
25 11 17 25 11 35 -15 7 -19 17 -25 40 -25 17 0 30 5 31 13 6 82 -5 216 -19
242 -36 63 -127 86 -241 62z m178 -181 c30 -36 -27 -69 -121 -70 -68 -1 -93
17 -72 52 18 27 173 43 193 18z"/><path d="M4605 553 c-47 -17 -85 -50 -85 -74 0 -22 50 -73 87 -87 15 -6 53
-13 84 -17 72 -8 101 -27 78 -50 -25 -26 -109 -30 -168 -9 -48 17 -52 17 -68
1 -64 -63 201 -102 292 -43 26 17 38 66 25 101 -12 32 -54 50 -155 67 -68 11
-80 16 -80 32 0 29 48 38 128 25 77 -12 101 -4 81 29 -23 37 -147 51 -219 25z"/><path d="M6585 561 c-93 -24 -125 -66 -125 -162 0 -59 2 -64 39 -99 66 -63
180 -77 267 -34 42 21 48 31 34 54 -7 12 -14 12 -43 2 -60 -22 -146 -16 -188
14 -60 41 -44 49 83 46 67 -3 128 1 151 8 38 11 39 13 33 48 -7 44 -33 81 -72
104 -34 19 -136 30 -179 19z m148 -82 c29 -35 21 -39 -88 -39 -111 0 -129 9
-82 40 54 36 139 35 170 -1z"/><path d="M7150 551 c-24 -12 -34 -12 -54 -2 -55 30 -61 18 -64 -124 -4 -166
-1 -177 41 -173 32 3 32 3 37 94 3 60 11 98 21 115 18 27 77 50 109 42 16 -4
20 0 20 18 0 13 -4 30 -8 36 -10 16 -62 12 -102 -6z"/><path d="M7563 560 c-123 -18 -180 -131 -118 -235 43 -74 160 -105 263 -71 63
21 77 36 58 62 -13 17 -18 17 -48 6 -63 -22 -152 -16 -187 14 -17 14 -31 30
-31 35 0 5 53 9 118 9 132 0 192 12 192 38 0 9 -11 37 -23 61 -36 70 -111 97
-224 81z m139 -77 c36 -32 11 -43 -93 -43 -105 0 -125 11 -76 43 44 29 136 29
169 0z"/><path d="M3186 552 c-5 -9 54 -156 102 -252 26 -51 30 -55 62 -55 34 0 36 2
81 93 26 51 49 95 52 98 6 6 57 -99 57 -116 0 -33 44 -79 76 -80 29 0 50 26
79 98 14 34 41 92 60 128 43 81 44 94 6 94 -31 0 -65 -33 -76 -73 -10 -38 -60
-127 -70 -127 -6 0 -29 44 -51 98 -41 95 -42 97 -74 97 -19 0 -36 -6 -40 -15
-66 -142 -99 -196 -110 -184 -4 5 -20 43 -35 84 -35 101 -49 120 -85 120 -16
0 -31 -4 -34 -8z"/><path d="M1848 459 c-5 -4 -8 -17 -6 -30 3 -24 3 -24 406 -27 402 -2 402 -2
402 34 0 36 0 36 -396 32 -218 -1 -400 -6 -406 -9z"/><path d="M8305 462 c-3 -3 -5 -18 -5 -34 0 -28 0 -28 395 -28 395 0 395 0 395
29 0 20 -6 31 -17 35 -23 6 -762 4 -768 -2z"/></g>
            <g transform="translate(0.000000,1136.000000) scale(0.100000,-0.100000)" fill="var(--logo-check)" stroke="none"><path d="M7503 6340 c-3 -12 -24 -29 -47 -40 -43 -19 -69 -43 -79 -72 -4 -11
-17 -18 -32 -18 -14 0 -25 -6 -25 -13 0 -16 -68 -82 -93 -90 -9 -4 -22 -18
-27 -32 -5 -14 -15 -25 -23 -25 -16 0 -137 -121 -137 -138 0 -7 -11 -17 -25
-22 -14 -5 -30 -21 -35 -35 -5 -14 -12 -25 -15 -25 -3 0 -10 11 -15 25 -5 14
-21 30 -35 35 -14 5 -25 15 -25 22 0 7 -10 18 -22 23 -13 6 -28 20 -34 33 -16
32 -65 82 -81 82 -7 0 -18 11 -23 25 -13 35 -37 41 -63 18 -12 -11 -29 -23
-38 -26 -9 -3 -23 -19 -32 -35 -14 -30 -14 -30 57 -101 39 -39 76 -71 82 -71
13 0 84 -73 84 -86 0 -13 63 -74 76 -74 6 0 19 -9 29 -20 29 -32 94 -27 130
10 16 17 35 30 42 30 7 0 13 10 13 23 0 23 47 77 66 77 6 0 23 14 39 30 16 17
35 30 42 30 7 0 13 5 13 12 0 15 50 68 65 68 15 0 229 220 245 252 10 21 10
30 1 42 -9 10 -9 16 -1 21 14 9 -6 35 -26 35 -8 0 -19 11 -24 25 -12 30 -20
32 -27 5z"/></g>
        </svg>
    );
}
